(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('sellersList', sellersList);

    /* @ngInject */
    function sellersList($rootScope) {
        var directive = {
            bindToController: true,
            templateUrl: 'sellers-list.tpl',
            controller: sellersListController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                data: '=',
                searchModel: '=',
                topTen: '@'
            }
        };
        return directive;

        function link(scope, element, attrs, ngModel) {
            angular.forEach(scope.vm.data, function(seller, sidx) {
                //scope.vm.data[sidx].img = !scope.vm.data[sidx].photo.value ? $rootScope.globals.default.individualImg : seller.photo.value.sizes.thumbnail.url;
                if (scope.$root.checkChain(scope.vm.data[sidx],'photo,value,sizes,thumbnail')) {
                    scope.vm.data[sidx].img = seller.photo.value.sizes.thumbnail.url;
                } else {
                    scope.vm.data[sidx].img = $rootScope.globals.default.individualImg;
                }
            });
        }
    }

    /* @ngInject */
    function sellersListController ($scope, $rootScope) {
        $scope.vm.baseurl = baseurl;
        $rootScope.selectedSeller = undefined;
        $rootScope.selectedSellerName = '';
        $scope.selectSeller = function(sellerID, firstName, lastName) {
            $rootScope.selectedSeller = sellerID;
            $rootScope.selectedSellerName = lastName + ', ' + firstName;
        };
        // $scope.vm.baseurl = 'http://pie.dev.limusdesign.com';

        $scope.listFilter = function(li) {
            if (!$scope.vm.searchModel) {
                return true;
            }
            var ss = $scope.vm.searchModel.toLowerCase();
            return (li['first-name'].value.toLowerCase().indexOf(ss) === 0) ||
                    (li['last-name'].value.toLowerCase().indexOf(ss) === 0) ||
                    (li.id.value.toString().indexOf(ss) != -1) ||
                    (li.team_name.toLowerCase().indexOf(ss) === 0);
        };

    }

})();